module.exports = __webpack_public_path__ + "img/userRead_bg.2f3a1f84.png";